module.exports = __webpack_public_path__ + "img/PSG.cbf50c5d.png";